(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dt-white-cast"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__wcTooltipInit) return;
    window.__wcTooltipInit = true;

    function closeAll(except) {
      document.querySelectorAll('.wc__tip-wrap.is-open').forEach(function (wrap) {
        if (wrap === except) return;
        wrap.classList.remove('is-open');
        var b = wrap.querySelector('.wc__tip-btn');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    }

    // click / tap toggle
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.wc__tip-btn');
      if (btn) {
        e.preventDefault();
        var wrap = btn.closest('.wc__tip-wrap');
        var open = !wrap.classList.contains('is-open');
        closeAll(wrap);
        wrap.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        return;
      }
      if (!e.target.closest('.wc__tip')) closeAll();
    });

    // Esc closes
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });

    // close when scrolling far away on touch devices
    window.addEventListener('scroll', function () {
      if (!window.matchMedia('(hover: hover)').matches) closeAll();
    }, { passive: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
